import axios from 'axios';
import config from '../config';
import { handleServiceResponse } from '../hof/handleServiceResponse';

export class Blogs {
    static getBlogs = async () => {

        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/blogs',
                method: 'GET'
            };
            const { data } = await axios(options)
            return data;
        });
    }

    static getBlog = async (id) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/blogs/' + id,
                method: 'GET'
            };
            const { data } = await axios(options)
            return data;
        });
    }

    static createNewBlog = async (domain, title, slogan, theme) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/blogs',
                method: 'POST',
                data: {
                    domain, title, slogan, theme
                }
            };
            const { data } = await axios(options)
            console.log(data);
            return data;
        });
    }

    static deleteBlog = async (id) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/blogs/' + id,
                method: 'DELETE'
            };
            const { data } = await axios(options)
            return data;
        });

    }

    static addCategory = async (blogId, name, slug) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/categories',
                method: 'POST',
                data: {
                    blogId,
                    name,
                    slug
                }
            };
            const { data } = await axios(options)
            return data;
        });

    }

    static deleteCategory = async (id) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/categories',
                method: 'DELETE',
                data: { id }
            };
            const { data } = await axios(options)
            return data;
        });

    }

    static updateCategory = async (id, name, slug) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/categories',
                method: 'PUT',
                data: {
                    id,
                    name,
                    slug
                }
            };
            const { data } = await axios(options)
            return data;
        });

    }

    static updateBlogSettings = async (blogId, settings) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/blogs/' + blogId,
                method: 'PUT',
                data: {
                    ...settings
                }
            };
            const { data } = await axios(options)
            console.log(data);
            return data;
        });

    }


}